import { apiRequest } from './client'
import { trackDraftWrite } from './draftWrites'
import type { FileKey } from '@/types/bundle'

// GET /gui/v1/drafts/current/files/{file_key} (PRD 21) - draft-or-live,
// copy-on-write: returns the draft edit if one exists, else reads through to
// the live bundle. Raw file content passthrough, same convention as
// getBundleFile in src/api/bundles.ts.
export function getDraftFile<T>(fileKey: FileKey): Promise<T> {
  return apiRequest<T>(`/gui/v1/drafts/current/files/${fileKey}`)
}

// PUT /gui/v1/drafts/current/files/{file_key} (PRD 21) - whole-file replace,
// validated in-process against PRD 22 before persisting. PRD 21 doesn't
// document the success response body, so fall back to the content just sent
// if the backend returns an empty body.
export async function putDraftFile<T>(fileKey: FileKey, content: T): Promise<T> {
  const result = await trackDraftWrite(
    apiRequest<T | undefined>(`/gui/v1/drafts/current/files/${fileKey}`, {
      method: 'PUT',
      body: JSON.stringify(content),
    }),
  )
  return result ?? content
}

// DELETE /gui/v1/drafts/current/files/{file_key} (PRD 21) - removes that
// file's draft edit; idempotent no-op if none exists.
export async function discardDraftFile(fileKey: FileKey): Promise<void> {
  await apiRequest<void>(`/gui/v1/drafts/current/files/${fileKey}`, { method: 'DELETE' })
}
